(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7817],{

/***/ 60269:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-creators",
      function () {
        return __webpack_require__(82255);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ ThumbnailNotReadyError; },
  "q": function() { return /* binding */ VideoApi; }
});

// EXTERNAL MODULE: ../next-utils/src/lib/HttpClient.ts
var HttpClient = __webpack_require__(74552);
// EXTERNAL MODULE: ../contracts/src/errors/AxiosResponseError.ts
var AxiosResponseError = __webpack_require__(86104);
;// CONCATENATED MODULE: ../contracts/src/media/thumbnail-type.enum.ts
var ThumbnailType;
(function(ThumbnailType) {
    ThumbnailType["STRIP"] = "strip";
    ThumbnailType["CUSTOM"] = "custom";
})(ThumbnailType || (ThumbnailType = {}));

;// CONCATENATED MODULE: ./modules/Api/Video/VideoApi.ts


class VideoApi {
    async createMediaVideo() {
        return this.client.post("/api/media/videos");
    }
    async getMyMediaData(id) {
        return this.client.get("/api/accounts/me/videos/".concat(id));
    }
    async getMediaData(idOrSlug) {
        return this.client.get("/api/media/videos/".concat(idOrSlug), {}, false);
    }
    async submitMedia(id, data) {
        return this.client.patch("/api/media/videos/".concat(id), data);
    }
    async getVideoUpload(id) {
        return this.client.get("/api/media/videos/".concat(id, "/upload"));
    }
    async createThumbnail(id) {
        return this.client.post("/api/media/videos/".concat(id, "/thumbnail"), {});
    }
    async putAttachmentToSignedUrl(signedUrl, file) {
        await this.client.put(signedUrl, file, {
            headers: {
                "Content-Type": ""
            }
        });
    }
    async updateThumbnail(videoId, thumbnailId) {
        return this.client.patch("/api/media/videos/".concat(videoId, "/thumbnail/").concat(thumbnailId), {}).catch((e)=>{
            if ((0,AxiosResponseError/* isAxiosResponseError */.G)(e) && e.response.status === 409) {
                throw new ThumbnailNotReadyError();
            }
            throw e;
        });
    }
    async createThumbnailFromStrip(id, index) {
        return this.client.post("/api/media/videos/".concat(id, "/thumbnail"), {
            type: ThumbnailType.STRIP,
            thumbstripIndex: index
        });
    }
    async getVideoStrips(id) {
        let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 320;
        return this.client.get("/api/jwplayer/strips/".concat(id, "-").concat(size, ".vtt"), {
            headers: {
                "Content-Type": "text/html"
            }
        });
    }
    async publish(id) {
        return this.client.post("/api/media/videos/".concat(id, "/publish"), {});
    }
    async submit(id) {
        return this.client.post("/api/media/videos/".concat(id, "/submit"), {});
    }
    async delete(id) {
        return this.client.delete("/api/media/videos/".concat(id), {});
    }
    async toggleLike(id) {
        return this.client.put("/api/media/videos/".concat(id, "/like"));
    }
    async getPopularVideos(params) {
        return this.client.get("/api/media/videos/popular", {
            params
        }, false);
    }
    async getPopularCreators(params) {
        return this.client.get("/api/media/accounts/popular", {
            params
        }, false);
    }
    async getMapVideos(boundingBox, zoom) {
        return this.client.get("/api/map/videos", {
            params: {
                algoliaBB: boundingBox,
                superclusterBB: mapBoundsToSuperclusterBounds(boundingBox),
                zoom
            }
        }, false);
    }
    constructor(client = new HttpClient/* HttpClient */.e()){
        this.client = client;
    }
}
class ThumbnailNotReadyError extends Error {
}
function mapBoundsToSuperclusterBounds(boundingBox) {
    return [
        boundingBox[1],
        boundingBox[2],
        boundingBox[3],
        boundingBox[0]
    ];
}


/***/ }),

/***/ 20416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ CTAList; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/ItemsList/ItemsList.tsx
var ItemsList = __webpack_require__(14927);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/link.js
var next_link = __webpack_require__(66998);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../ui/src/components/SimpleImage/index.tsx
var SimpleImage = __webpack_require__(86978);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ../ui/src/icons/ArrowRight/ArrowRight.tsx
var ArrowRight = __webpack_require__(71740);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../ui/src/components/CTA/CTACard/CTACard.tsx





const CTACard = (param)=>{
    let { data , renderImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "min-w-[293px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-[244px] w-full rounded-2xl overflow-hidden mb-6",
                children: renderImage ? renderImage(data) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                    src: data.img,
                    className: "object-cover",
                    alt: data.title,
                    fill: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "h4",
                        className: "mb-1 text-neutral-900 lg:mb-2",
                        children: data.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "bodyXL",
                        className: "text-neutral-600 mb-4",
                        children: data.text
                    }),
                    isCTAWithButton(data) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        disabled: data.disabled,
                        className: classnames_default()("flex items-center gap-1 text-sm font-semibold", {
                            "text-neutral-600": !data.disabled,
                            "text-neutral-200": data.disabled
                        }),
                        onClick: data.onClick,
                        children: [
                            data.buttonText,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                                className: classnames_default()("w-6 h-6", {
                                    "text-primary-500": !data.disabled,
                                    "text-primary-100": data.disabled
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: data.disabled ? "#" : data.linkHref,
                        className: classnames_default()("flex items-center gap-1text-sm font-semibold", {
                            "text-neutral-600": !data.disabled,
                            "text-neutral-200": data.disabled
                        }),
                        children: [
                            data.linkText,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                                className: classnames_default()("w-6 h-6", {
                                    "text-primary-500": !data.disabled,
                                    "text-primary-100": data.disabled
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function isCTAWithButton(data) {
    return data.onClick !== undefined;
}

;// CONCATENATED MODULE: ./modules/CallToAction/CTAList/CTAList.tsx



const CTAList = (param)=>{
    let { data , renderImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
        className: "w-full flex overflow-x-auto gap-[20px] pb-4 md:gap-8 lg:gap-12",
        items: data,
        renderItem: (cta)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CTACard, {
                data: cta,
                renderImage: renderImage
            })
    });
};


/***/ }),

/***/ 8471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useResolveUserPublicProfilePagePath; }
/* harmony export */ });
/* harmony import */ var _Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65729);

const useResolveUserPublicProfilePagePath = (userId)=>{
    const { pageUrl  } = (0,_Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__/* .useConfig */ .ZR)();
    return "".concat(pageUrl, "/users/").concat(userId);
};


/***/ }),

/***/ 50853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Share; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3862);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);



const DynamicShare = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>__webpack_require__.e(/* import() */ 1798).then(__webpack_require__.bind(__webpack_require__, 1798)).then((mod)=>mod.DynamicShare), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1798)
            ]
    },
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1798)
            ]
    },
    suspense: false,
    ssr: false
});
function Share(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicShare, {
        ...props
    });
}


/***/ }),

/***/ 98523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ TruncatedTagsList; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Tag/Tag.tsx
var Tag = __webpack_require__(90202);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/useWindowSize/useWindowSize.tsx
var useWindowSize = __webpack_require__(16485);
;// CONCATENATED MODULE: ./modules/Tags/TruncatedTagsList/hooks.ts


function useTruncatedList(ref) {
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    const [hiddenElements, setHiddenElements] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (!ref.current) return;
        const listElements = getListElements(ref.current);
        const listWidth = ref.current.offsetWidth;
        const elements = hideElementsThatNotFit(listElements, listWidth);
        setHiddenElements(elements.hiddenElements);
    }, [
        width
    ]);
    function getListElements(list) {
        return Array.from(list.querySelectorAll("li"));
    }
    function hideElementsThatNotFit(elements, containerWidth) {
        return elements.reduce((acc, el)=>{
            const nextTagsWidth = acc.tagsWidth + el.offsetWidth;
            let nextHiddenElements = acc.hiddenElements;
            if (nextTagsWidth + 120 > containerWidth) {
                el.style.position = "absolute";
                el.style.opacity = "0";
                nextHiddenElements++;
            } else {
                el.removeAttribute("style");
            }
            return {
                tagsWidth: nextTagsWidth,
                hiddenElements: nextHiddenElements
            };
        }, {
            tagsWidth: 0,
            hiddenElements: 0
        });
    }
    return {
        hiddenElements
    };
}

;// CONCATENATED MODULE: ./modules/Tags/TruncatedTagsList/TruncatedTagsList.tsx





const TruncatedTagsList = (param)=>{
    let { tags , color ="gray" , prefixTag , suffixTag , className  } = param;
    const listRef = (0,react.useRef)(null);
    const { hiddenElements  } = useTruncatedList(listRef);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        ref: listRef,
        className: classnames_default()("max-w-full w-full flex gap-1 overflow-hidden", className),
        children: [
            prefixTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline-block",
                children: prefixTag
            }),
            tags.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    style: {
                        position: "absolute",
                        opacity: 0
                    },
                    className: "inline-block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                        value: tag.name,
                        size: "sm",
                        color: color
                    })
                }, tag.id)),
            suffixTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline-block",
                children: suffixTag
            }),
            hiddenElements > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                id: "list-counter",
                value: "+ ".concat(hiddenElements, " more"),
                color: "gray"
            })
        ]
    });
};


/***/ }),

/***/ 75983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ AuthorCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59785);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38937);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35368);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66998);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Pages_UserPublicProfilePage_path__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8471);
/* harmony import */ var _Tags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98523);
/* harmony import */ var _Share_Share__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50853);
/* harmony import */ var _NextAvatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77420);









const AuthorCard = (param)=>{
    let { data , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: (0,_Pages_UserPublicProfilePage_path__WEBPACK_IMPORTED_MODULE_4__/* .useResolveUserPublicProfilePagePath */ .D)(data.cognito_id),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("group relative p-4 bg-white rounded-2xl w-full min-w-[344px] h-[314px] hover:shadow-3xl group transition-all duration-200 cursor-pointer", className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "bg-neutral-100 p-3 rounded-full w-fit",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NextAvatar__WEBPACK_IMPORTED_MODULE_5__/* .NextAvatar */ .t, {
                        src: data.avatar_key,
                        size: "xl",
                        className: "drop-shadow-sm"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .Z, {
                    component: "h3",
                    variant: "h5",
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-3 mb-1 text-neutral-900 line-clamp-1 md:text-xl"),
                    children: data.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .Z, {
                    variant: "bodyLarge",
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-neutral-600 !text-xs mb-3 line-clamp-5 h-[80px]"),
                    children: data.description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_6__/* .Typography */ .Z, {
                    variant: "bodyLarge",
                    className: "!text-xs text-neutral-700 font-medium flex items-center gap-1 mb-1",
                    children: [
                        data.subscriptionsCount,
                        " subscribers"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tags__WEBPACK_IMPORTED_MODULE_7__/* .TruncatedTagsList */ .z, {
                    tags: data.tags
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute top-2 right-2 lg:opacity-0 lg:group-hover:opacity-100 transition duration-200",
                    onClick: (e)=>e.preventDefault(),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Share_Share__WEBPACK_IMPORTED_MODULE_8__/* .Share */ .m, {
                        data: {
                            title: data.name,
                            url: (0,_Pages_UserPublicProfilePage_path__WEBPACK_IMPORTED_MODULE_4__/* .useResolveUserPublicProfilePagePath */ .D)(data.cognito_id)
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_9__/* .IconButton */ .h, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_10__/* .ShareIcon */ .a, {
                                className: "w-6 h-6"
                            }),
                            variant: "text"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 82255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ for_creators; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/OutsidePageWrapper.tsx
var OutsidePageWrapper = __webpack_require__(55368);
// EXTERNAL MODULE: ./modules/User/AuthorCard/AuthorCard.tsx
var AuthorCard = __webpack_require__(75983);
// EXTERNAL MODULE: ./modules/User/User.ts
var User = __webpack_require__(22535);
;// CONCATENATED MODULE: ./modules/Pages/BecomeCreatorPage/PopularCreatorsList/PopularCreatorList.tsx



const PopularCreatorList = (param)=>{
    let { data  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "w-full gap-[20px] grid grid-cols-[minmax(min-content,_1fr)_minmax(min-content,_1fr)_minmax(min-content,_1fr)] overflow-x-auto pb-4 md:gap-8 lg:gap-12 lg:pb-8 lg:overflow-x-visible",
        children: data.map((user)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorCard/* AuthorCard */.c, {
                    data: User/* User.fromExtendedAccountDto */.n.fromExtendedAccountDto(user)
                })
            }, user.cognito_id))
    });
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tanstack+react-query@4.2.1_biqbaboplfbrettd7655fr4n2y/node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(15265);
// EXTERNAL MODULE: ./modules/Api/Video/VideoApi.ts + 1 modules
var VideoApi = __webpack_require__(94633);
;// CONCATENATED MODULE: ./modules/Pages/BecomeCreatorPage/hooks.ts


const useCreators = ()=>{
    const videoApi = new VideoApi/* VideoApi */.q();
    const useCreatorsQuery = (pagination)=>{
        return (0,index_production.useQuery)([
            "popular-authors",
            pagination
        ], async ()=>await videoApi.getPopularCreators(pagination), {
            keepPreviousData: true
        });
    };
    return {
        useCreatorsQuery
    };
};

// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
;// CONCATENATED MODULE: ./modules/Pages/BecomeCreatorPage/OurCreatorsSection/OurCreatorsSection.tsx





const OurCreatorsSection = ()=>{
    const { useCreatorsQuery  } = useCreators();
    const { data: creators  } = useCreatorsQuery({
        page: 1,
        limit: 3,
        search: null
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-10 pl-4 md:pl-[30px] lg:px-10 lg:py-[80px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full max-w-6xl mx-auto ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "h2",
                        className: "pr-4 text-neutral-900 mb-6 md:pr-[30px] lg:mb-[61px]",
                        children: "Get inspired by our creators"
                    }),
                    creators && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularCreatorList, {
                        data: creators.data
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./modules/CallToAction/CTAList/CTAList.tsx + 1 modules
var CTAList = __webpack_require__(20416);
// EXTERNAL MODULE: ./modules/Auth/AuthContext.tsx
var AuthContext = __webpack_require__(35836);
;// CONCATENATED MODULE: ./modules/Pages/BecomeCreatorPage/BecomeCreatorCTASection/BecomeCreatorCTASection.tsx





const BecomeCreatorCTASection = ()=>{
    const { useSession  } = (0,AuthContext/* useAuth */.a)();
    const { data: session  } = useSession();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white py-10 pl-4 md:pl-[30px] lg:px-10 lg:py-[80px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full max-w-6xl mx-auto ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        variant: "h2",
                        className: "pr-4 text-neutral-900 mb-6 md:pr-[30px] lg:hidden",
                        children: "How to start?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAList/* CTAList */.t, {
                        data: [
                            {
                                id: 1,
                                title: "Explore our map to get inspired - then find your park.",
                                text: "Travel with our map, see what other people submit and get inspired to travel.",
                                linkText: "Explore map",
                                linkHref: "/explore-parks",
                                img: "/media/road-phone.jpg"
                            },
                            {
                                id: 2,
                                title: "Sign up and read our guidelines",
                                text: "We carefully curate the videos on Parks Channel. Learn what works and what doesn't.",
                                linkText: "Read guidelines",
                                linkHref: "/utilities/guidelines",
                                img: "/media/mountain-camera.jpg"
                            },
                            {
                                id: 3,
                                title: "Share videos",
                                text: "Select videos and share with the community. Inspire others and become an influencer!.",
                                linkText: "Upload a video",
                                linkHref: !session ? "/utilities/guidelines/" : "/videos/new",
                                img: "/media/mountain-man-photography.jpg"
                            }
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ../ui/src/components/SimpleImage/index.tsx
var SimpleImage = __webpack_require__(86978);
;// CONCATENATED MODULE: ./modules/Pages/BecomeCreatorPage/BecomeCreatorCover/BecomeCreatorCover.tsx



const BecomeCreatorCover = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative bg-neutral-200 w-full h-[460px] rounded-2xl overflow-hidden lg:h-[635px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute top-0 left-0 w-full h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                        src: "/media/for-creators.jpg",
                        alt: "Become creator page cover",
                        fill: true,
                        className: "object-cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full bg-gradient-to-b from-black/20 to-black/50"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-6 w-full h-full relative bg-transparent flex items-end md:px-10 md:py-[30px] lg:px-[116px] lg:pb-[102px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: "max-w-[521px] lg:max-w-[775px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            variant: "h1",
                            className: "line-clamp-3 text-white mb-2 md:text-[40px] md:leading-[44px] lg:mb-3",
                            children: "Share your videos and earn a chance to win a prize!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            variant: "bodyXL",
                            className: "line-clamp-3 text-white ",
                            children: "Entertain. Inform. And win Parks Channel swag. The best videos will earn t-shirts and other cool items."
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/useButtonsAnalytics.tsx
var useButtonsAnalytics = __webpack_require__(76356);
;// CONCATENATED MODULE: ./modules/Pages/BecomeCreatorPage/BecomeCreatorPage.tsx







const BecomeCreatorPage = ()=>{
    (0,useButtonsAnalytics/* useButtonsAnalytics */.V)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomeCreatorCover, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BecomeCreatorCTASection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurCreatorsSection, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/for-creators.tsx

var __N_SSP = true;
/* harmony default export */ var for_creators = (BecomeCreatorPage);


/***/ }),

/***/ 76356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useButtonsAnalytics; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _useAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24900);


const useButtonsAnalytics = ()=>{
    const { onButtonClick  } = (0,_useAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z)();
    const listenEvent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e)=>{
        if (!e || !e.target) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        onButtonClick(e.target.textContent);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!document) return;
        const buttons = document.querySelectorAll("button");
        buttons.forEach((button)=>button.addEventListener("click", listenEvent));
        return ()=>{
            buttons.forEach((button)=>button.removeEventListener("click", listenEvent));
        };
    }, []);
};


/***/ }),

/***/ 16485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

function useWindowSize() {
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0
    });
    const handleSize = ()=>{
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        window.addEventListener("resize", handleSize);
        handleSize();
        return ()=>window.removeEventListener("resize", handleSize);
    }, []);
    return windowSize;
}


/***/ }),

/***/ 22063:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(65271)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(52009)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(52983));
var _loadable = _interop_require_default(__webpack_require__(90692));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 5594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(52009)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(52983));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 90692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(65271)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(9371)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(52983));
var _loadableContext = __webpack_require__(5594);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 86104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ isAxiosResponseError; }
/* harmony export */ });
function isAxiosResponseError(error) {
    return typeof error === "object" && error !== null && "response" in error;
}


/***/ }),

/***/ 14927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ItemsList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function ItemsList(param) {
    let { items , renderItem , className , liClassName , noItemsMessage ="Not found" , noItemsClassName  } = param;
    if (items.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("font-medium text-sm text-neutral-900 my-5 text-center block", noItemsClassName),
            children: noItemsMessage
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className),
        children: items.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full", liClassName),
                children: renderItem(item)
            }, item.id))
    });
}


/***/ }),

/***/ 90202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59785);




const Tag = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)((param)=>{
    let { id , value , size ="sm" , color ="transparent" , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
        variant: "bodySmall",
        id: id,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("normal-case rounded-full text-neutral-700 inline-block font-medium whitespace-nowrap", tagSize(size), tagColor(color), className),
        children: typeof value === "string" ? capitalizeFirstLetter(value) : value
    });
});
function tagSize(size) {
    switch(size){
        case "sm":
            return "py-1 px-2";
        default:
            return "py-2 px-4";
    }
}
function tagColor(color) {
    switch(color){
        case "orange":
            return "bg-orange1";
        case "yellow":
            return "bg-yellow1";
        case "transparent":
            return "bg-transparent";
        case "gray":
            return "bg-neutral-100";
        case "darkGray":
            return "bg-neutral-200";
        case "light":
            return "bg-white";
        default:
            return "bg-".concat(color);
    }
}
function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}


/***/ }),

/***/ 55368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OutsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const OutsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-4 w-full max-w-screen-2xl mx-auto md:p-[30px] lg:p-10", className),
        children: children
    });
};


/***/ }),

/***/ 71740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ArrowRight = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        className: className,
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17 8L21 12M21 12L17 16M21 12H3",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 35368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ShareIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


const ShareIcon = (param)=>/*#__PURE__*/ {
    let { className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.78875 8.89446C5.92342 8.62514 5.99942 8.32116 5.99942 7.99985C5.99942 7.67854 5.92342 7.37456 5.78875 7.10524M5.78875 8.89446C5.58722 9.29736 5.25555 9.62042 4.84748 9.81131C4.43941 10.0022 3.97883 10.0497 3.54037 9.94619C3.10191 9.84266 2.71125 9.59414 2.43168 9.24088C2.15211 8.88763 2 8.45034 2 7.99985C2 7.54936 2.15211 7.11207 2.43168 6.75882C2.71125 6.40556 3.10191 6.15704 3.54037 6.05351C3.97883 5.94998 4.43941 5.99751 4.84748 6.18839C5.25555 6.37928 5.58722 6.70234 5.78875 7.10524M5.78875 8.89446L10.2101 11.105M5.78875 7.10524L10.2101 4.89472M10.2101 11.105C9.97283 11.5795 9.93379 12.1289 10.1016 12.6322C10.2694 13.1355 10.6302 13.5515 11.1048 13.7888C11.5793 14.0261 12.1287 14.0651 12.6321 13.8973C13.1354 13.7296 13.5515 13.3687 13.7888 12.8942C14.0261 12.4197 14.0651 11.8703 13.8973 11.367C13.7296 10.8637 13.3687 10.4476 12.8941 10.2104C12.6591 10.0929 12.4033 10.0228 12.1413 10.0042C11.8792 9.9856 11.6161 10.0188 11.3668 10.1018C10.8635 10.2696 10.4474 10.6305 10.2101 11.105ZM10.2101 4.89472C10.3276 5.12964 10.4902 5.33912 10.6887 5.5112C10.8871 5.68328 11.1175 5.81458 11.3667 5.89763C11.6159 5.98067 11.8791 6.01381 12.1411 5.99518C12.4031 5.97654 12.6589 5.90648 12.8938 5.78899C13.1287 5.67151 13.3382 5.50891 13.5103 5.31047C13.6824 5.11203 13.8137 4.88164 13.8968 4.63246C13.9798 4.38327 14.013 4.12017 13.9943 3.85818C13.9757 3.59618 13.9056 3.34042 13.7881 3.1055C13.5508 2.63106 13.1348 2.2703 12.6315 2.10259C12.1282 1.93488 11.5789 1.97396 11.1044 2.21123C10.63 2.44849 10.2692 2.86451 10.1015 3.36776C9.93375 3.87101 9.97283 4.42028 10.2101 4.89472Z",
            stroke: "currentColor",
            strokeWidth: "1.3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 3862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(22063)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(60269); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);